import { LitElement, css, html } from 'lit';
import { localized, msg } from '@lit/localize';
import { customElement, state } from 'lit/decorators.js';
import { globalStyles } from '../global-styles.js';
import policySections from '../utils/policy.js';
import { getLocale } from '../locale/localization.js';

@localized()
@customElement('pp-policy')
export class PpPolicy extends LitElement {
  static styles = [
    globalStyles,
    css`
      :host {
        display: block;
        direction: ltr;
      }
      
      .pp-privacy-policy {
        text-decoration: underline;
        color: var(--pp-checkout-black-45);
      }
    `,
  ];

  @state() _policyDialog: boolean = false;

  private closePolicy() {
    this._policyDialog = false;
  }

  async openPolicy() {
    this._policyDialog = true;
  }


  render() {
    const locale = getLocale();

    const sections = policySections[locale.includes('zh')? 'ZH': 'EN'];

    const { title, content } = sections;

    return html`
      <p class="pp-privacy-policy text-xs cursor-p align-center" @click=${this.openPolicy}>
        ${msg('Privacy Policy')}
      </p>
      <pp-dialog
        ?visible=${this._policyDialog}
        ?center=${true}
        width="80%"
        @close=${this.closePolicy}
      >
        <header class="text-lg strong">${ title }</header>
        <main>
          ${ content.map(item => {
            const { title, content } = item;
            return html`
              <section class="section m-b-2">
                <h2 class="m-b-1 strong">${title}</h2>
                ${content.map((con) => {
                  const { text, strong } = con;
                  return html`<p class="m-b-1 ${strong? 'strong': ''}">${text}</p>`
                })}
              </section>
            `
          })}
        </main>
      </pp-dialog>
    `
  }
}